import {
  Avatar,
  Button,
  Checkbox,
  Flex,
  Icon,
  Input,
  Select,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  Stack,
  Box,
  Switch
} from "@chakra-ui/react";
import NewIcon from "assets/svg/newIcon.svg";
import React, { useMemo, useState } from "react";
import { GrFormNext, GrFormPrevious } from "react-icons/gr";
import { FaCheckCircle, FaEdit, FaTrash, FaTimesCircle, FaExclamationCircle, FaUndoAlt, FaArchive } from "react-icons/fa";
import {
  TiArrowSortedDown,
  TiArrowSortedUp,
  TiArrowUnsorted,
} from "react-icons/ti";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";

function SearchTable2(props) {
  const { columnsData, tableData, onEdit, onDelete, onDeliveryDateChange, onStatusChange } = props;

  const [selectedOrders, setSelectedOrders] = useState([]);
  const [toggleStates, setToggleStates] = useState({});

  const handleToggle = (orderId) => {
    setToggleStates((prev) => ({
      ...prev,
      [orderId]: !prev[orderId],
    }));
  };


  const handleCheckboxChange = (orderId) => {
    setSelectedOrders((prev) =>
      prev.includes(orderId)
        ? prev.filter((id) => id !== orderId) // Uncheck
        : [...prev, orderId] // Check
    );
  };

  const columns = useMemo(
    () => [
      {
        Header: "Order ID",
        accessor: "orderId",
        Cell: ({ row }) => (


          <Flex align="center">
              
            <Checkbox size="lg" colorScheme="teal" me="8px" isChecked={selectedOrders.includes(row.original.orderId)}
              onChange={() => handleCheckboxChange(row.original.orderId)} />
            <Text>{row.original.orderId}</Text>
          </Flex>

        ),
      },
      { Header: "Order Date", accessor: "orderDate" },
      {
        Header: "Delivery Date",
        accessor: "deliveryDate",
        // Cell: ({ row }) => (
        //   <Input
        //     type="date"
        //     defaultValue={row.original.deliveryDate}
        //   // onChange={(e) => onDeliveryDateChange(row.original, e.target.value)}
        //   />
        // ),
      },

      {
        Header: "Order Status",
        accessor: "orderStatus",
        Cell: ({ cell }) => (
          <Flex align="center">
            {cell.value === "New" ? (
              <svg
                width="22"
                height="22"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ marginRight: "6px" }}
              >
                <circle cx="10" cy="10" r="10" fill="#3182CE" />
                <path d="M10 5V11" stroke="white" strokeWidth="2" strokeLinecap="round" />
                <circle cx="10" cy="14" r="1" fill="white" />
              </svg>
            ) : (
              <Icon
                as={
                  cell.value === "Completed"
                    ? FaCheckCircle
                    : FaTimesCircle
                }
                color={cell.value === "Completed" ? "green.400" : "red.400"}
                w="22px"
                h="22px"
                me="6px"
              />
            )}
            <Text>{cell.value}</Text>
          </Flex>
        ),
      },
      {
        Header: "Client Name",
        accessor: "fullname",
        Cell: ({ cell }) => {
          const [fullName, company] = cell.value.split(" (");

          // Truncate full name and company name if longer than 12 characters
          const displayName = fullName.length > 12 ? `${fullName.slice(0, 12)}...` : fullName;
          const displayCompany = company
            ? company.slice(0, 12) + (company.length > 12 ? "..." : "")
            : "";

          // Get first letter of full name for Avatar
          const avatarLetter = fullName.charAt(0).toUpperCase();

          return (
            <Flex align="center">
              <Avatar
                name={cell.value.split(" ").join()[0]}
                w="30px"
                h="30px"
                me="6px"
                bg="#530000"
              />
              <Box ml="8px">
                <Text fontWeight="bold" whiteSpace="nowrap">{displayName}</Text>
                {displayCompany && (
                  <Text fontSize="sm" color="gray.500" isTruncated maxW="150px">
                    {displayCompany}
                  </Text>
                )}
              </Box>
            </Flex>
          );
        },
      },
      { Header: "Assigned Driver", accessor: "assignedDriver" },

      {
        Header: "Amount",
        accessor: "amount",
        Cell: ({ cell }) => (
          <Text >
            € {cell.value}
          </Text>
        ),
      },

      {
        Header: "Action",
        accessor: "action",
        Cell: ({ row }) => (
          <Flex gap={3}>
            <Icon
              as={FaEdit}
              color="blue.500"
               w="20px"
                h="20px"
              cursor="pointer"
              onClick={() => onEdit(row.original)}
            />
          <Switch colorScheme="green" isChecked={toggleStates[row.original.orderId] || false} onChange={() => handleToggle(row.original.orderId)} />
          </Flex>
        ),
      },
    ],
    [onEdit, onDelete, onDeliveryDateChange, onStatusChange, selectedOrders,toggleStates]
  );


  const data = useMemo(() => tableData, [tableData]);

  const tableInstance = useTable(
    { columns, data },
    useGlobalFilter,
    useSortBy,
    usePagination
  );
  const createPages = (count) => {
    let arrPageCount = [];

    for (let i = 1; i <= count; i++) {
      arrPageCount.push(i);
    }

    return arrPageCount;
  };

  const {  getTableBodyProps, headerGroups, page, prepareRow, setGlobalFilter, state, getTableProps,

    gotoPage,
    pageCount,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    setPageSize } = tableInstance;
  const { pageIndex, pageSize, globalFilter } = state;

  return (
    <Flex direction="column" w="100%"> {/* Set a height */}
      <Flex   align={{ sm: "flex-start", lg: "flex-end" }}
          justify={{ sm: "flex-start", lg: "flex-end" }}
          w="100%"
          px="22px"
          mb="36px">
        <Input
          type="text"
          placeholder="Search..."
          minW="75px"
          maxW="175px"
          fontSize="sm"
          _focus={{ borderColor: "teal.300" }}
          onChange={(e) => setGlobalFilter(e.target.value)}
        />
      </Flex>

      {/* Wrapping table in a scrollable div */}
      <Flex overflowX="auto"  >
        <Table {...getTableProps()} variant="simple" color="gray.500" mb="24px">
          <Thead>
            {headerGroups.map((headerGroup, index) => (
              <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
                {headerGroup.headers.map((column, index) => (
                  <Th {...column.getHeaderProps(column.getSortByToggleProps())} key={index}>
                    <Flex justify="space-between" align="center" fontSize="12px" color="gray.400">
                      {column.render("Header")}
                      <Icon
                        w="14px"
                        h="14px"
                        color={column.isSorted ? "gray.500" : "gray.400"}
                        as={column.isSorted ? (column.isSortedDesc ? TiArrowSortedDown : TiArrowSortedUp) : TiArrowUnsorted}
                      />
                    </Flex>
                  </Th>
                ))}
              </Tr>
            ))}
          </Thead>
          <Tbody {...getTableBodyProps()}>
            {page.map((row, index) => {
              prepareRow(row);
              return (
                <Tr {...row.getRowProps()} key={index}>
                  {row.cells.map((cell, index) => (
                    <Td {...cell.getCellProps()} key={index} fontSize="14px" minW="150px">
                      {cell.render("Cell")}
                    </Td>
                  ))}
                </Tr>
              );
            })}
          </Tbody>
        </Table>
       
      </Flex>
       <Flex
          direction={{ sm: "column", md: "row" }}
          justify="space-between"
          align="center"
          px="22px"
          w="100%"
          px={{ md: "22px" }}
        >
          <Text
            fontSize="sm"
            color="gray.500"
            fontWeight="normal"
            mb={{ sm: "24px", md: "0px" }}
          >
            Showing {pageSize * pageIndex + 1} to{" "}
            {pageSize * (pageIndex + 1) <= tableData.length
              ? pageSize * (pageIndex + 1)
              : tableData.length}{" "}
            of {tableData.length} entries
          </Text>
          <Stack direction="row" alignSelf="flex-end" spacing="4px" ms="auto">
            <Button
              variant="no-hover"
              onClick={() => previousPage()}
              transition="all .5s ease"
              w="40px"
              h="40px"
              borderRadius="50%"
              bg="#fff"
              border="1px solid lightgray"
              display={
                pageSize === 5 ? "none" : canPreviousPage ? "flex" : "none"
              }
              _hover={{
                bg: "gray.200",
                opacity: "0.7",
                borderColor: "gray.500",
              }}
            >
              <Icon as={GrFormPrevious} w="16px" h="16px" color="gray.400" />
            </Button>
            {pageSize === 5 ? (
              <NumberInput
                max={pageCount - 1}
                min={1}
                w="75px"
                mx="6px"
                defaultValue="1"
                onChange={(e) => gotoPage(e)}
              >
                <NumberInputField />
                <NumberInputStepper>
                  <NumberIncrementStepper onClick={() => nextPage()} />
                  <NumberDecrementStepper onClick={() => previousPage()} />
                </NumberInputStepper>
              </NumberInput>
            ) : (
              createPages(pageCount).map((pageNumber, index) => {
                return (
                  <Button
                    variant="no-hover"
                    transition="all .5s ease"
                    onClick={() => gotoPage(pageNumber - 1)}
                    w="40px"
                    h="40px"
                    borderRadius="160px"
                    bg={pageNumber === pageIndex + 1 ? "teal.300" : "#fff"}
                    border="1px solid lightgray"
                    _hover={{
                      bg: "gray.200",
                      opacity: "0.7",
                      borderColor: "gray.500",
                    }}
                    key={index}
                  >
                    <Text
                      fontSize="xs"
                      color={pageNumber === pageIndex + 1 ? "#fff" : "gray.600"}
                    >
                      {pageNumber}
                    </Text>
                  </Button>
                );
              })
            )}
            <Button
              variant="no-hover"
              onClick={() => nextPage()}
              transition="all .5s ease"
              w="40px"
              h="40px"
              borderRadius="160px"
              bg="#fff"
              border="1px solid lightgray"
              display={pageSize === 5 ? "none" : canNextPage ? "flex" : "none"}
              _hover={{
                bg: "gray.200",
                opacity: "0.7",
                borderColor: "gray.500",
              }}
            >
              <Icon as={GrFormNext} w="16px" h="16px" color="gray.400" />
            </Button>
          </Stack>
        </Flex>
    </Flex>

  );
}

export default SearchTable2;